module.exports = __webpack_public_path__ + "static/media/_MIC2506.thumbnail.6b12f4b9.png";